import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface TasksKeyType {
  abortTasks: LocalesKey;
  addTags: LocalesKey;
  addMessage: LocalesKey;
  addLdCustomerId: LocalesKey;
  addLdProductId: LocalesKey;
  addLdReferencePath: LocalesKey;
  addLdStatus: LocalesKey;
  addLdSku: LocalesKey;
  addSku: LocalesKey;
  all: LocalesKey;
  alreadyMember: LocalesKey;
  acceptResults: LocalesKey;
  active: LocalesKey;
  addAsManyTasksAsYouNeedToCreateInOneGoClickTheTaskToEditItsDetails: LocalesKey;
  areYouSureYouWantToDeleteThisTaskYouWillNotBeAbleToUndoThisAction: LocalesKey;
  areYouCertainAboutLeavingTheTaskPleaseBeAwareOfTheFollowingOutcomes: LocalesKey;
  areYouSureYouWantToStartTheTask: LocalesKey;
  areYouSureYouWantToRefreshTheTaskStatus: LocalesKey;
  addAssociatedProduct: LocalesKey;
  backToTasksList: LocalesKey;
  cell: LocalesKey;
  channels: LocalesKey;
  confirmAndStart: LocalesKey;
  cannotStartTaskWithNoItemsBoundToTheCurrentSmartContract: LocalesKey;
  cannotCheckInTheSmartContractWithNoShares: LocalesKey;
  cautionItemsInSmartContractAreNotBoundToTheDepositInvoiceAndYouShallStartTheTaskAtYourOwnRisk: LocalesKey;
  basedOnTaskDetailsTheSuggestedEstimateDateIsDateAndTheExpectedWorkTimeIsTime: LocalesKey;
  cancelingSmartContract: LocalesKey;
  coefficient: LocalesKey;
  creatingDepositInvoice: LocalesKey;
  delete: LocalesKey;
  dueDateLocked: LocalesKey;
  duplicate: LocalesKey;
  finalResult: LocalesKey;
  fullyPaid: LocalesKey;
  id: LocalesKey;
  hide: LocalesKey;
  list: LocalesKey;
  ldProductId: LocalesKey;
  payingInvoices: LocalesKey;
  plural: LocalesKey;
  singular: LocalesKey;
  singularLowerCase: LocalesKey;
  new: LocalesKey;
  create: LocalesKey;
  createTaskOnly: LocalesKey;
  createTasksOnly: LocalesKey;
  createMultiple: LocalesKey;
  createSingle: LocalesKey;
  current: LocalesKey;
  changeStatus: LocalesKey;
  create_new: LocalesKey;
  view: LocalesKey;
  version: LocalesKey;
  valid: LocalesKey;
  nonValid: LocalesKey;
  noSmartContracts: LocalesKey;
  viewPlural: LocalesKey;
  name: LocalesKey;
  description: LocalesKey;
  downloadResults: LocalesKey;
  displayOptions: LocalesKey;
  areYouSureYouWantLeaveTaskThisActionCannotBeUndone: LocalesKey;
  add: LocalesKey;
  addDescription: LocalesKey;
  addNotes: LocalesKey;
  addName: LocalesKey;
  buttons: {
    abort: LocalesKey;
    accept: LocalesKey;
    approve: LocalesKey;
    cancel: LocalesKey;
    checkIn: LocalesKey;
    checkInWithoutFollowers: LocalesKey;
    checkInWithFollowers: LocalesKey;
    close: LocalesKey;
    continue: LocalesKey;
    pause: LocalesKey;
    pendingMoreInfo: LocalesKey;
    restore: LocalesKey;
    restart: LocalesKey;
    sendToRevision: LocalesKey;
    startTask: LocalesKey;
  };
  canceledPluralLowerCase: LocalesKey;
  canceledLowerCase: LocalesKey;
  doneLowerCase: LocalesKey;
  editDescription: LocalesKey;
  editNotes: LocalesKey;
  editVersion: LocalesKey;
  editAssociatedProduct: LocalesKey;
  goTo: LocalesKey;
  goToProject: LocalesKey;
  import: LocalesKey;
  importAllocate: LocalesKey;
  taskUnavailableForCertainActions: LocalesKey;
  temporaryAccessLimitation: LocalesKey;
  tasksIn: LocalesKey;
  tasksToAdd: LocalesKey;
  tasksToCreate: LocalesKey;
  invitedUsers: LocalesKey;
  inviteToMultipleTasks: LocalesKey;
  inviteUser: LocalesKey;
  invitations: LocalesKey;
  isClosed: LocalesKey;
  jobStatus: {
    start: LocalesKey;
    cancel: LocalesKey;
    accept: LocalesKey;
    processing: LocalesKey;
  };
  jobFailed: {
    start: LocalesKey;
    cancel: LocalesKey;
    accept: LocalesKey;
    processing: LocalesKey;
  };
  ldSku: LocalesKey;
  sku: LocalesKey;
  ldCustomerId: LocalesKey;
  ldReferencePath: LocalesKey;
  ldStatus: LocalesKey;
  myFinance: LocalesKey;
  myNotes: LocalesKey;
  myResults: LocalesKey;
  myTimeline: LocalesKey;
  namesHaveToBeUnique: LocalesKey;
  noPlural: LocalesKey;
  pleaseRate: LocalesKey;
  processingJobs: LocalesKey;
  product: LocalesKey;
  predictedEstimateDate: LocalesKey;
  finishTasks: LocalesKey;
  finishMultipleTasks: LocalesKey;
  results: LocalesKey;
  restartJob: LocalesKey;
  refreshStatus: LocalesKey;
  roundCounter: LocalesKey;
  singularAttachments: LocalesKey;
  showHiddenTasks: LocalesKey;
  showOnlyHiddenTasks: LocalesKey;
  showCanceledTasks: LocalesKey;
  showDoneTasks: LocalesKey;
  allAttachments: LocalesKey;
  multiple: LocalesKey;
  mute: LocalesKey;
  muteAllTasks: LocalesKey;
  missingSourceFiles: LocalesKey;
  my: LocalesKey;
  noVisibleTasksFound: LocalesKey;
  notes: LocalesKey;
  receiveNotificationsFromAllTasks: LocalesKey;
  search: LocalesKey;
  searchByTaskName: LocalesKey;
  searchTasksByNameOrUser: LocalesKey;
  selectSingular: LocalesKey;
  sendInvoice: LocalesKey;
  setDueDate: LocalesKey;
  selectShareToCheckInWith: LocalesKey;
  status: LocalesKey;
  states: {
    qa: LocalesKey;
    buttons: {
      accept: LocalesKey;
      approve: LocalesKey;
      cancel: LocalesKey;
      checkIn: LocalesKey;
      pause: LocalesKey;
      pendingMoreInfo: LocalesKey;
      restore: LocalesKey;
      restart: LocalesKey;
      sendToRevision: LocalesKey;
    };
  };
  statusChange: LocalesKey;
  submitAsTaskResult: LocalesKey;
  submitResults: LocalesKey;
  submitAsSourceFile: LocalesKey;
  submitSourceFiles: LocalesKey;
  submittedResults: LocalesKey;
  selectTaskToSeeMessages: LocalesKey;
  startedCreatingItems: LocalesKey;
  startNewVersion: LocalesKey;
  tableSettings: LocalesKey;
  taskDueDatesCannotBeChangedWhenTheStatusIs: LocalesKey;
  timeline: LocalesKey;
  toProject: LocalesKey;
  findResultsInAttachments: LocalesKey;
  optionalWhenYouExpectTheTaskToBeFinished: LocalesKey;
  leave: LocalesKey;
  tags: LocalesKey;
  thisTaskCurrentlyCannotProceedWithFinancialOperationsOrStatusChangesDueToFollowingActiveProcesses: LocalesKey;
  executionOfFinancialOperationsAndStatusChangesIsSuspendedUntilTheCompletionOf: LocalesKey;
  pluralLowerCase: LocalesKey;
  taskName: LocalesKey;
  tasksInProgress: LocalesKey;
  taskTeam: LocalesKey;
  taskMuted: LocalesKey;
  team: LocalesKey;
  total: LocalesKey;
  trackTaskTime: LocalesKey;
  trackedToday: LocalesKey;
  trackTimeInMultipleTasks: LocalesKey;
  trackTime: LocalesKey;
  track: LocalesKey;
  thisTaskIsHidden: LocalesKey;
  unhide: LocalesKey;
  optional: LocalesKey;
  caution: LocalesKey;
  addedToProcessing: LocalesKey;
  goToSmartContract: LocalesKey;
  goToProfileSettings: LocalesKey;
  withoutSourceFiles: LocalesKey;
  workload: LocalesKey;
  myWithoutSourceFiles: LocalesKey;
  voidItems: LocalesKey;
  youCanNotStartTheTaskWithRefundedInvoices: LocalesKey;
  youWillNoLongerReceiveNotificationsRelatedToThisTask: LocalesKey;
  theTaskWillBeExcludedFromYourMyTasksList: LocalesKey;
  itWontBeIncludedInSearchResultsFilteredByYouAsATaskMember: LocalesKey;
  inviteTeamMembersToTheTaskUponTaskCreation: LocalesKey;
  clientFeedback: LocalesKey;
  errorCorrections: LocalesKey;
  unforeseenCircumstances: LocalesKey;
  highWorkload: LocalesKey;
  noneOfTheAbove: LocalesKey;
  noTasksAvailableToAbort: LocalesKey;
  selectReason: LocalesKey;
  inaccurateForecast: LocalesKey;
  technicalIssue: LocalesKey;
  clientTerms: LocalesKey;
}

export const tasksKeys = keyPathMirror<TasksKeyType, string>(
  {
    abortTasks: null,
    addTags: null,
    addMessage: null,
    addLdCustomerId: null,
    addLdProductId: null,
    addLdReferencePath: null,
    addLdStatus: null,
    addLdSku: null,
    addSku: null,
    all: null,
    alreadyMember: null,
    acceptResults: null,
    active: null,
    addAsManyTasksAsYouNeedToCreateInOneGoClickTheTaskToEditItsDetails: null,
    areYouSureYouWantToDeleteThisTaskYouWillNotBeAbleToUndoThisAction: null,
    areYouCertainAboutLeavingTheTaskPleaseBeAwareOfTheFollowingOutcomes: null,
    areYouSureYouWantToStartTheTask: null,
    areYouSureYouWantToRefreshTheTaskStatus: null,
    addAssociatedProduct: null,
    backToTasksList: null,
    cell: null,
    channels: null,
    confirmAndStart: null,
    cannotStartTaskWithNoItemsBoundToTheCurrentSmartContract: null,
    cannotCheckInTheSmartContractWithNoShares: null,
    cautionItemsInSmartContractAreNotBoundToTheDepositInvoiceAndYouShallStartTheTaskAtYourOwnRisk:
      null,
    basedOnTaskDetailsTheSuggestedEstimateDateIsDateAndTheExpectedWorkTimeIsTime:
      null,
    cancelingSmartContract: null,
    coefficient: null,
    creatingDepositInvoice: null,
    delete: null,
    dueDateLocked: null,
    duplicate: null,
    finalResult: null,
    fullyPaid: null,
    id: null,
    hide: null,
    list: null,
    ldProductId: null,
    payingInvoices: null,
    plural: null,
    singular: null,
    singularLowerCase: null,
    new: null,
    changeStatus: null,
    create: null,
    createTaskOnly: null,
    createTasksOnly: null,
    createMultiple: null,
    createSingle: null,
    create_new: null,
    current: null,
    view: null,
    version: null,
    valid: null,
    nonValid: null,
    noSmartContracts: null,
    viewPlural: null,
    name: null,
    description: null,
    downloadResults: null,
    displayOptions: null,
    add: null,
    areYouSureYouWantLeaveTaskThisActionCannotBeUndone: null,
    addDescription: null,
    addNotes: null,
    addName: null,
    buttons: {
      abort: null,
      accept: null,
      approve: null,
      cancel: null,
      checkIn: null,
      checkInWithoutFollowers: null,
      checkInWithFollowers: null,
      close: null,
      continue: null,
      pause: null,
      pendingMoreInfo: null,
      restore: null,
      restart: null,
      sendToRevision: null,
      startTask: null
    },
    canceledPluralLowerCase: null,
    canceledLowerCase: null,
    doneLowerCase: null,
    editDescription: null,
    editNotes: null,
    editVersion: null,
    editAssociatedProduct: null,
    goTo: null,
    goToProject: null,
    taskDueDatesCannotBeChangedWhenTheStatusIs: null,
    tasksIn: null,
    tasksToAdd: null,
    tasksToCreate: null,
    invitedUsers: null,
    inviteToMultipleTasks: null,
    inviteUser: null,
    invitations: null,
    import: null,
    importAllocate: null,
    taskUnavailableForCertainActions: null,
    temporaryAccessLimitation: null,
    isClosed: null,
    jobStatus: {
      start: null,
      cancel: null,
      accept: null,
      processing: null
    },
    jobFailed: {
      start: null,
      cancel: null,
      accept: null,
      processing: null
    },
    ldSku: null,
    sku: null,
    ldCustomerId: null,
    ldReferencePath: null,
    ldStatus: null,
    myFinance: null,
    myNotes: null,
    myResults: null,
    myTimeline: null,
    namesHaveToBeUnique: null,
    noPlural: null,
    pleaseRate: null,
    processingJobs: null,
    product: null,
    predictedEstimateDate: null,
    finishTasks: null,
    finishMultipleTasks: null,
    results: null,
    restartJob: null,
    refreshStatus: null,
    roundCounter: null,
    search: null,
    searchByTaskName: null,
    searchTasksByNameOrUser: null,
    selectSingular: null,
    sendInvoice: null,
    setDueDate: null,
    selectShareToCheckInWith: null,
    singularAttachments: null,
    showHiddenTasks: null,
    showOnlyHiddenTasks: null,
    showCanceledTasks: null,
    showDoneTasks: null,
    allAttachments: null,
    multiple: null,
    mute: null,
    muteAllTasks: null,
    missingSourceFiles: null,
    my: null,
    noVisibleTasksFound: null,
    notes: null,
    receiveNotificationsFromAllTasks: null,
    states: {
      qa: null,
      buttons: {
        accept: null,
        approve: null,
        cancel: null,
        checkIn: null,
        pause: null,
        pendingMoreInfo: null,
        restore: null,
        restart: null,
        sendToRevision: null
      }
    },
    status: null,
    statusChange: null,
    submitAsTaskResult: null,
    submitResults: null,
    submitAsSourceFile: null,
    submitSourceFiles: null,
    submittedResults: null,
    selectTaskToSeeMessages: null,
    startedCreatingItems: null,
    startNewVersion: null,
    toProject: null,
    findResultsInAttachments: null,
    optionalWhenYouExpectTheTaskToBeFinished: null,
    leave: null,
    tableSettings: null,
    timeline: null,
    tags: null,
    thisTaskCurrentlyCannotProceedWithFinancialOperationsOrStatusChangesDueToFollowingActiveProcesses:
      null,
    executionOfFinancialOperationsAndStatusChangesIsSuspendedUntilTheCompletionOf:
      null,
    taskName: null,
    tasksInProgress: null,
    taskTeam: null,
    taskMuted: null,
    pluralLowerCase: null,
    team: null,
    total: null,
    trackTaskTime: null,
    trackedToday: null,
    trackTimeInMultipleTasks: null,
    trackTime: null,
    track: null,
    thisTaskIsHidden: null,
    unhide: null,
    optional: null,
    caution: null,
    addedToProcessing: null,
    goToSmartContract: null,
    goToProfileSettings: null,
    withoutSourceFiles: null,
    workload: null,
    myWithoutSourceFiles: null,
    voidItems: null,
    youCanNotStartTheTaskWithRefundedInvoices: null,
    youWillNoLongerReceiveNotificationsRelatedToThisTask: null,
    theTaskWillBeExcludedFromYourMyTasksList: null,
    itWontBeIncludedInSearchResultsFilteredByYouAsATaskMember: null,
    inviteTeamMembersToTheTaskUponTaskCreation: null,
    clientFeedback: null,
    errorCorrections: null,
    unforeseenCircumstances: null,
    highWorkload: null,
    noneOfTheAbove: null,
    noTasksAvailableToAbort: null,
    selectReason: null,
    inaccurateForecast: null,
    technicalIssue: null,
    clientTerms: null
  },
  'models.tasks.'
);
